import React from "react"
import { Link, To } from "react-router-dom"
import classNames from "utils/classNames"

export interface StyledLinkProps {
  /**
   * If set to `true`, the Link will have a grey underline
   * @default true
   */
  text?: boolean
  /**
   * * If set to try the link will have no click property
   * * @default false
   */
  disabled?: boolean
  className?: string
  to?: To
  state?: any
  [key: string]: any
}
const StyledLink = ({
  children,
  className,
  text,
  disabled,
  to,
  state,
  ...props
}: StyledLinkProps) => {
  return (
    <Link
      to={to}
      state={state}
      className={classNames(
        "vt-styled-link",
        { "vt-styled-link-text": text, "vt-styled-link-disabled": disabled },
        className
      )}
      {...props}
    >
      {children}
    </Link>
  )
}

StyledLink.defaultProps = {
  text: true,
}
export default StyledLink
